import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Badge } from '../ui/badge';

export default function JourneyDetailDialog({ detailModal, setDetailModal, report, engagement }) {
  return (
    <Dialog open={!!detailModal} onOpenChange={(open) => !open && setDetailModal(null)}>
      <DialogContent className="max-w-3xl" data-testid="journey-detail-dialog">
        <DialogHeader>
          <DialogTitle>Journey Details</DialogTitle>
        </DialogHeader>
        {detailModal?.type === 'milestones' && (
          <div className="space-y-3">
            {Object.entries(report.journey_summary.milestones_by_category).map(([cat, data]) => (
              <div key={cat} className="rounded-xl border border-slate-200 p-3">
                <p className="text-xs uppercase text-muted-foreground mb-2">{data.name}</p>
                {data.milestones.length ? (
                  <ul className="space-y-1 text-sm">
                    {data.milestones.map((m, idx) => (
                      <li key={`item-${idx}`} className="flex items-center justify-between">
                        <span>{m.title}</span>
                        <span className="text-xs text-muted-foreground">{m.date}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-xs text-muted-foreground">No milestones recorded yet.</p>
                )}
              </div>
            ))}
          </div>
        )}
        {detailModal?.type === 'progress' && (
          <div className="space-y-2">
            <p className="text-sm">Journey completion: <strong>{report.journey_summary.progress_percent}%</strong></p>
            <p className="text-sm">Total milestones completed: <strong>{report.journey_summary.total_milestones}</strong></p>
            <p className="text-xs text-muted-foreground">Progress reflects milestones recorded to date.</p>
          </div>
        )}
        {detailModal?.type === 'achievements' && (
          <div className="space-y-2">
            {report.achievements.length ? report.achievements.map((a, idx) => (
              <div key={`item-${idx}`} className="p-3 rounded-xl bg-amber-50 border border-amber-200">
                <p className="text-sm font-semibold">{a.title}</p>
                <p className="text-xs text-muted-foreground">{a.date}</p>
                {a.description && <p className="text-xs text-slate-600 mt-1">{a.description}</p>}
              </div>
            )) : (
              <p className="text-sm text-muted-foreground">No achievements recorded yet.</p>
            )}
          </div>
        )}
        {detailModal?.type === 'achievement' && (
          <div className="space-y-2">
            <p className="text-sm font-semibold">{detailModal.achievement?.title}</p>
            <p className="text-xs text-muted-foreground">{detailModal.achievement?.date}</p>
            {detailModal.achievement?.description && (
              <p className="text-sm text-slate-700">{detailModal.achievement.description}</p>
            )}
          </div>
        )}
        {detailModal?.type === 'checkins' && (
          <div className="space-y-2">
            <p className="text-sm font-semibold">Check-in Dates</p>
            <div className="flex flex-wrap gap-2">
              {(engagement.checkin_dates || []).map(date => (
                <Badge key={date} variant="secondary">{date}</Badge>
              ))}
            </div>
          </div>
        )}
        {detailModal?.type === 'sober' && (
          <div className="space-y-2">
            <p className="text-sm">Sober days start date:</p>
            <p className="text-sm font-semibold">{engagement.sober_start_date || 'Not recorded yet'}</p>
          </div>
        )}
        {detailModal?.type === 'workdays' && (
          <div className="space-y-2">
            <p className="text-sm font-semibold">Workday Dates</p>
            <div className="flex flex-wrap gap-2">
              {(engagement.work_day_dates || []).map(date => (
                <Badge key={date} variant="secondary">{date}</Badge>
              ))}
            </div>
          </div>
        )}
        {detailModal?.type === 'roadmap' && (
          <div className="space-y-2">
            <p className="text-sm font-semibold">Roadmap Steps</p>
            <div className="space-y-2">
              {(engagement.roadmap_steps || []).map(step => (
                <div key={step.milestone_key} className="p-3 rounded-xl border border-slate-200">
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-semibold">{step.title}</p>
                    <Badge variant="secondary" className={step.completed ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}>
                      {step.completed ? 'Completed' : 'Pending'}
                    </Badge>
                  </div>
                  <p className="text-xs text-muted-foreground">{step.completed_date || 'Awaiting approval'}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
